import React, { useEffect, useRef } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  ListGroup,
  Form,
  FloatingLabel,
  Button,
} from "react-bootstrap";
import image from "../../assets/images/new/contact-us.png";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { websiteData } from "../../utils/data";

import emailjs from "@emailjs/browser";

const Contact = () => {
  const formData = useRef();

  useEffect(() => {
    document.title = `Contact Us | ${websiteData.company_name}`;
    window.scroll(0, 0);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        formData.current,
        process.env.REACT_APP_PUBLIC_KEY,
      )
      .then(
        () => {
          // alert("success");
          formData.current.reset();
          console.error("SUCCESS");
        },
        (error) => {
          alert(`Error: ${error.text}`);
          console.error(error);
        },
      );
  };

  return (
    <>
      <Breadcrumbs title="Contact us" pagename="Contact us" />
      <section className="contact  pt-5">
        <Container>
          <Row>
            <Col md="12">
              <h1 className="mb-2 h1 font-bold">
                Let's connect, create, and grow.
                <br />
                Reach out to our team today.
              </h1>
              <p className=" mt-1">
                Ready to bring your vision to life? Let's build something
                unforgettable together.
              </p>
            </Col>
          </Row>
          <Row className="py-5">
            <Col lg="4" md="6" className="mb-4 mb-lg-0">
              <Card className="border-0 shadow rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="bg-info rounded-circle text-info shadow-sm bg-opacity-10 p-3 mb-2 ">
                      <i className="bi bi-headset h3"></i>
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">Call US</Card.Title>
                  <p className="mb-3 body-text">
                    Have a project in mind? We're just a call away.
                  </p>
                  <div className="d-block justify-content-between">
                    {/*  <a type="button" className="btn btn-light me-2 btn-sm">
                      <i className="bi bi-phone me-1"></i>
                      +12 3456 789
                    </a> */}
                    <a type="button" className="btn btn-light me-2 btn-sm">
                      <i className="bi bi-telephone me-1"></i>
                      {websiteData.phone_one}
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg="4" md="6" className="mb-4 mb-lg-0">
              <Card className="border-0 shadow rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="bg-danger rounded-circle text-danger shadow-sm bg-opacity-10 p-3 mb-2 ">
                      <i className="bi bi-envelope h3"></i>
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">Email Us</Card.Title>
                  <p className="mb-3 body-text">
                    Send us your brief, and let’s get to work.
                  </p>
                  <div className="d-block justify-content-between">
                    <a type="button" className="btn btn-light me-2 btn-sm">
                      <i className="bi bi-envelope me-2"></i>
                      {websiteData.email}
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg="4" md="12" className="mb-4 mb-lg-0">
              <Card className="border-0 shadow rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="bg-warning rounded-circle text-warning shadow-sm bg-opacity-10 p-3 mb-2 ">
                      <i className="bi bi-globe h3"></i>
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">Social Media</Card.Title>
                  <p className="mb-3 body-text">
                    Stay connected with our latest projects.
                  </p>
                  <div className="d-block justify-content-center">
                    <ListGroup horizontal className="justify-content-center">
                      {/* <ListGroup.Item className="border-0">
                        <i className="bi bi-youtube"></i>
                      </ListGroup.Item> */}
                      <ListGroup.Item className="border-0">
                        <a target="_blank" href={`${websiteData.instagram}`}>
                          {/* <i className="bi bi-instagram"></i> */}
                          {websiteData.instagramDisplay}
                        </a>
                      </ListGroup.Item>
                      {/* <ListGroup.Item className="border-0">
                        <i className="bi bi-twitter"></i>
                      </ListGroup.Item> */}
                      {/* <ListGroup.Item className="border-0">
                        <i className="bi bi-youtube"></i>
                      </ListGroup.Item> */}
                    </ListGroup>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="pb-5 align-items-center">
            <Col xl="6" md="6" className="d-none d-md-block">
              <img src={image} alt="" className="img-fluid me-3" />
            </Col>
            <Col xl="6" md="6">
              <Card className="bg-light p-4 border-0 shadow-sm">
                <div className="form-box">
                  <h1 className="h3 font-bold mb-4">Send us message</h1>
                  <Form ref={formData} onSubmit={sendEmail}>
                    <Row>
                      <Col md="6">
                        <FloatingLabel
                          controlId="user_name"
                          label="Full Name "
                          className="mb-4"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Full Name"
                            name="user_name"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col md="6">
                        <FloatingLabel
                          controlId="user_email"
                          label="Email address"
                          className="mb-4"
                        >
                          <Form.Control
                            type="email"
                            name="user_email"
                            placeholder="name@example.com"
                          />
                        </FloatingLabel>
                      </Col>

                      <Col md="12">
                        <FloatingLabel
                          controlId="user_phone"
                          label="Phone Number"
                          className="mb-4"
                        >
                          <Form.Control
                            type="text"
                            name="user_phone"
                            placeholder="Phone Number"
                          />
                        </FloatingLabel>
                      </Col>

                      <Col md="12">
                        <FloatingLabel
                          controlId="email_content"
                          label="Message"
                        >
                          <Form.Control
                            as="textarea"
                            placeholder="Message"
                            name="email_content"
                            style={{ height: "126px" }}
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                    <button
                      className="primaryBtn mt-3"
                      type="button"
                      onClick={sendEmail}
                    >
                      Send Message
                    </button>
                  </Form>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
